import ActionsGenerator from '../../lib/ActionsGenerator'

const generator = new ActionsGenerator('issuer_status', '/issuer_statuses')
const actions = generator.generate()

export default actions
